import {
  Backdrop,
  Button,
  ChartNew,
  FormFieldSet,
  InfoCardNewAdv,
  InfoTimeCardAdv,
  InfoWrapper,
  LogoLoader,
  Modal,
  ProgressBar,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";

import { useEffect, useLayoutEffect, useState } from "react";
import { formatCurrency } from "../../../../utils/stringUtils";
import { getDashboardData } from "../../../../utils/dashboard";
import dayjs from "dayjs";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { usePagination } from "../../../../hooks";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { reportPeriodOptions } from "../../../../assets/data/enumData";
import KpiViewModal from "../../Dashboard/Modals/KpiViewModal";
import { useDispatch } from "react-redux";
import { dateFormator, mapTableRows } from "../../../../utils";
import InvoiceDetails from "../../Invoices/Invoices/InvoiceDetails";
import { getCurrentInvoiceStart } from "../../../../redux/slices/invoices/invoicesSlice";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";
import { fetchAccountPaybles } from "../../../../redux/slices/accountPayables/accountPayablesApi";

const DropdownOptions = [
  { label: "ALL", value: "all" },
  { label: "IT", value: 3 },
  { label: "NON-IT", value: 2 },
  { label: "W2", value: 1 },
];

const revenueFlowData = [
  { label: "Jan", month: 1, value: 0, invoices: 0, revenue: 0 },
  { label: "Feb", month: 2, value: 0, invoices: 0, revenue: 0 },
  { label: "Mar", month: 3, value: 0, invoices: 0, revenue: 0 },
  { label: "Apr", month: 4, value: 0, invoices: 0, revenue: 0 },
  { label: "May", month: 5, value: 0, invoices: 0, revenue: 0 },
  { label: "Jun", month: 6, value: 0, invoices: 0, revenue: 0 },
  { label: "Jul", month: 7, value: 0, invoices: 0, revenue: 0 },
  { label: "Aug", month: 8, value: 0, invoices: 0, revenue: 0 },
  { label: "Sep", month: 9, value: 0, invoices: 0, revenue: 0 },
  { label: "Oct", month: 10, value: 0, invoices: 0, revenue: 0 },
  { label: "Nov", month: 11, value: 0, invoices: 0, revenue: 0 },
  { label: "Dec", month: 12, value: 0, invoices: 0, revenue: 0 },
];

export const fetchApDashboardCards = async (from, to) => {
  try {
    if (!from || !to) return;
    const dashboard = await getDashboardData(
      {
        apDashboard: {
          type: "AG_STATS",
          value: [
            null,
            dayjs(from).format("YYYY-MM-DD"),
            dayjs(to).format("YYYY-MM-DD"),
          ],
        },
      },
      "Account_Payable",
    );
    let cardsResponse = dashboard?.[0] || {};
    const cardsData = [
      {
        title: "All Bills",
        value: formatCurrency(cardsResponse?.allBills),
      },
      {
        title: "Open Bills",
        value: formatCurrency(cardsResponse?.openBills),
      },
      {
        title: "Due Bills",
        value: formatCurrency(cardsResponse?.dueBills),
      },
      {
        title: "Paid Bills",
        value: formatCurrency(cardsResponse?.paidBills),
      },
    ];
    return cardsData || [];
  } catch (error) {
    console.error("Error in fetching dashboard cards", error);
  }
};

export const fetchApAgingReport = async (from, to, limit, page) => {
  try {
    const datesPayload = {
      from: from ? dayjs(from).format("YYYY-MM-DD") : null,
      to: to ? dayjs(to).format("YYYY-MM-DD") : null,
    };
    const dashboard = await getDashboardData(
      {
        vendorPendingPay: {
          type: "AG_LOOKUP_DATA",
          value: [null, datesPayload.from, datesPayload.to],
        },
      },
      "Account_Payable",
      limit,
      page,
    );
    let fetchedAgingReports = Array.isArray(dashboard) ? dashboard : [];
    const mappedFetchedAgingReports =
      fetchedAgingReports?.[0]?.data?.map((i) => ({
        "Vendor Name": i?.businessName || "",
        Current: i?.current ? formatCurrency(i?.current) : "-",
        "1-30": i?.upto30 ? formatCurrency(i?.upto30) : "-",
        "30-60": i?.upto60 ? formatCurrency(i?.upto60) : "-",
        "60-90": i?.upto90 ? formatCurrency(i?.upto90) : "-",
        "90+": i?.over90 ? formatCurrency(i?.over90) : "-",
      })) || [];
    return {
      agingReport: mappedFetchedAgingReports,
      ag2TotalCount: fetchedAgingReports?.[0]?.count?.[0]?.total || 0,
    };
  } catch (error) {
    console.error("Error in fetching aging reports", error);
  } finally {
  }
};

export const fetchApInfoGraphicBar = async () => {
  try {
    const dashboard = await getDashboardData(
      {
        allVendorPendingPay: {
          type: "AG_LOOKUP_DATA",
          value: [null],
        },
      },
      "Account_Payable",
    );
    let fetchedInfoGraphicBar = Array.isArray(dashboard) ? dashboard : [];
    return fetchedInfoGraphicBar[0];
  } catch (error) {
    console.error("Error in fetching aging reports", error);
  }
};

export const fetchApRevenueFlow = async (revenueType, year) => {
  try {
    if (revenueType === "all") {
      revenueType = null;
    }
    const response = await getDashboardData(
      {
        payoutByYear: {
          type: "AG_STATS",
          // second params is year// third param when we have dropdown-filter available-employementType
          value: [null, year, revenueType],
        },
      },
      "Account_Payable",
    );
    const data = revenueFlowData.map((list) => {
      let monthData = Array.isArray(response)
        ? response?.find((d) => d.month === list.month) || {}
        : {};
      return {
        ...list,
        value: monthData.revenue || 0,
        invoices: monthData.bills || 0,
        revenue: monthData.revenue || 0,
      };
    });
    return data || revenueFlowData;
  } catch (error) {
    console.error("Error in fetching revenue flow", error);
  }
};
export const KpiClickViewModal = ({
  isOpen,
  onClose,
  data,
  dataType,
  cardsDuration,
}) => {
  console.log("Kpi Click View Modal Rendered with dataType ", {
    isOpen,
    onClose,
    data,
    dataType,
    cardsDuration,
  });
  const dispatch = useDispatch();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalDisplay, setTotalDisplay] = useState({
    label: "",
    value: 0,
  });
  const [kpiData, setKpiData] = useState({
    data: [],
    totalCount: 0,
  });
  console.log({ kpiData });
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const rows = [
    {
      id: 1,
      uiid: 1,
      invoiceDate: "02/02/2026",
      transactionType: "Invoice",
      number: "342234",
      name: "NTT DATA Service Federal Gov.",
      memo: "Ravindra Rao (01/01/2026)",
      dueDate: "03/04/2026",
      amount: 19950.0,
      openingBalance: 19950.0,
    },
    {
      id: 2,
      uiid: 542,
      invoiceDate: "02/05/2026",
      transactionType: "Invoice",
      number: "16942",
      name: "Accenture LLP",
      memo: "Michael Scott (01/15/2026)",
      dueDate: "03/07/2026",
      amount: 12500.0,
      openingBalance: 12500.0,
    },
    {
      id: 3,
      uiid: 543,
      invoiceDate: "02/08/2026",
      transactionType: "Bill",
      number: "16951",
      name: "Deloitte Consulting",
      memo: "Sarah Johnson (01/20/2026)",
      dueDate: "03/10/2026",
      amount: 8750.0,
      openingBalance: 8750.0,
    },
    {
      id: 4,
      uiid: 544,
      invoiceDate: "02/10/2026",
      transactionType: "Invoice",
      number: "16950",
      name: "Infosys Ltd.",
      memo: "David Miller (01/25/2026)",
      dueDate: "03/12/2026",
      amount: 22300.0,
      openingBalance: 22300.0,
    },
    {
      id: 5,
      uiid: 545,
      invoiceDate: "02/12/2026",
      transactionType: "Credit Note",
      number: "16949",
      name: "Capgemini America",
      memo: "Emily Davis (01/28/2026)",
      dueDate: "03/14/2026",
      amount: -3200.0,
      openingBalance: -3200.0,
    },
    {
      id: 6,
      uiid: 546,
      invoiceDate: "02/15/2026",
      transactionType: "Invoice",
      number: "16948",
      name: "IBM Corporation",
      memo: "Robert Brown (02/01/2026)",
      dueDate: "03/17/2026",
      amount: 15600.0,
      openingBalance: 15600.0,
    },
    {
      id: 7,
      uiid: 547,
      invoiceDate: "02/18/2026",
      transactionType: "Bill",
      number: "16947",
      name: "Cognizant Technology",
      memo: "Olivia Wilson (02/05/2026)",
      dueDate: "03/20/2026",
      amount: 9400.0,
      openingBalance: 9400.0,
    },
    {
      id: 8,
      uiid: 548,
      invoiceDate: "02/20/2026",
      transactionType: "Invoice",
      number: "16952",
      name: "Tata Consultancy Services",
      memo: "James Anderson (02/07/2026)",
      dueDate: "03/22/2026",
      amount: 18250.0,
      openingBalance: 18250.0,
    },
  ];
  const columns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      width: "text-nowrap!",
      render: (row) => (
        <div
          className="text-info-500 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              getCurrentInvoiceStart({
                filters: { uiid: { type: "NONE", value: row.uiid } },
                coll: "Invoice",
                ref: "Client Employee Placement Timesheet",
                incl: ["", "firstName lastName", "", "attachments"],
              }),
            );
            setSelectedInvoice(row?.uiid);
          }}
        >
          {row?.invoiceNum}
        </div>
      ),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      width: "text-nowrap!",
      render: (row) => dateFormator(row?.invoiceDate),
    },
    {
      key: "dueDate",
      label: "Due Date",
      width: "text-nowrap!",
      render: (row) => dateFormator(row?.dueDate),
    },
    // {
    //   key: "transactionType",
    //   label: "Transaction Type",
    //   width: "text-nowrap!",
    // },
    {
      key: "employeeName",
      label: "Employee Name",
      width: "text-nowrap!",
      render: (row) => (
        <SmartTooltip
          description={[
            row?.employeeId?.[0]?.firstName || "--",
            row?.employeeId?.[0]?.lastName,
          ].join(" ")}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">
            {[
              row?.employeeId?.[0]?.firstName || "--",
              row?.employeeId?.[0]?.lastName,
            ].join(" ")}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "vendor",
      label: "Vendor Name",
      width: "text-nowrap!",
      render: (row) => row?.vendorId?.businessName || "",
    },
    {
      key: "billed_amount",
      label: "Bill Amount",
      width: "text-nowrap!",
      render: (row) => formatCurrency(row?.amounts?.billed),
    },
    {
      key: "paid_amount",
      label: "Paid Amount",
      width: "text-nowrap!",
      render: (row) => formatCurrency(row?.amounts?.paid),
    },
    {
      key: "discount_amount",
      label: "Discount Amount",
      width: "text-nowrap!",
      render: (row) => formatCurrency(row?.amounts?.discount),
    },
    {
      key: "memo",
      label: "Memo/ Description",
      width: "text-nowrap!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.memo}</div>
        </SmartTooltip>
      ),
    },
  ];

  const fetchData = async () => {
    try {
      let filters = {};
      const today = new Date();
      if (typeof dataType === "number") {
        if (!cardsDuration?.year) {
          showToast("Year is required for monthly data!", "error");
          return;
        }
        const { from, to } = getMonthDateRange(dataType, cardsDuration?.year);
        filters = {
          "version.isLatest": { type: "NONE", value: true },
          invoiceDate: {
            type: "RANGE",
            value: {
              from,
              to,
              variant: "root",
            },
          },
        };
      } else {
        switch (dataType) {
          case "All Bills": {
            filters = {
              invoiceDate: {
                type: "RANGE",
                value: {
                  from: cardsDuration?.from,
                  to: cardsDuration?.to,
                  variant: "root",
                },
              },
            };
            break;
          }
          case "Open Bills": {
            filters = {
              invoiceDate: {
                type: "RANGE",
                value: {
                  from: cardsDuration?.from,
                  to: cardsDuration?.to,
                  variant: "root",
                },
              },
              dueDate: { type: "GT", value: today },
              "amounts.billed": { type: "FIELD_EQ", value: "amounts.paid" },
            };
            break;
          }
          case "Due Bills": {
            filters = {
              invoiceDate: {
                type: "RANGE",
                value: {
                  from: cardsDuration?.from,
                  to: cardsDuration?.to,
                  variant: "root",
                },
              },
              dueDate: { type: "LT", value: today },
              "amounts.billed": { type: "FIELD_EQ", value: "amounts.due" },
            };
            break;
          }
          case "Paid Bills": {
            filters = {
              invoiceDate: {
                type: "RANGE",
                value: {
                  from: cardsDuration?.from,
                  to: cardsDuration?.to,
                  variant: "root",
                },
              },
              "amounts.billed": {
                type: "FIELD_EQ",
                value: "amounts.paid",
              },
              "amounts.due": { type: "NONE", value: 0 },
            };
            break;
          }
          default: {
            showToast("Something Went Wrong!", "error");
            return;
          }
        }
      }

      const params = {
        coll: "AccountPayable",
        filters,
        limit: limit,
        page: page,
        ref: "Employee Vendor Document Approver InvClient InvVendor",
        collection: "accountpayables",
        ret: "invoiceNum amounts clientId employeeId uiid invoiceDate dueDate memo",
        incl: [
          "firstName lastName employmentType",
          "businessName",
          "",
          "firstName lastName employementType",
          "businessName uiid",
          "businessName uiid",
        ],
      };
      const response = await fetchAccountPaybles(params);
      const total = await getTotalCountApi(params);
      // console.log({response})
      setKpiData({
        data: response?.data?.data || [],
        totalCount: total?.data?.data || 0,
      });
      setTotalDisplay({
        label: "Total Amount",
        value: response?.data?.data?.reduce((acc, curr) => acc + (dataType === "Paid Bills" ? curr.amounts.paid : curr.amounts.billed), 0),
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, dataType]);
  const mappedRows = mapTableRows(kpiData?.data || [], columns);
  return (
    <div>
      <div className="flex gap-3 justify-between mt-4">
        <Button
          size="md"
          title={"Back"}
          variant="text"
          icon={"arrow_left_alt"}
          color="black"
          className="px-0! bg-transparent!"
          onClick={onClose}
        />
        {totalDisplay?.value > 0 && <div className="pr-4">
          <InfoCardNewAdv title={totalDisplay.label} value={formatCurrency(totalDisplay.value)} />
        </div>}
      </div>
      <div className="hidden gap-3">
        Total Invoiced{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.invoiced, 0)}
        <br />
        Total Received{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.received, 0)}
        <br />
        Total Due{" "}
        {kpiData?.data?.reduce((acc, curr) => acc + curr.amounts.due, 0)}
        <br />
      </div>
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          tableId={"dashboard_apdashboard_kpiclicktable"}
          showSlNo
          columns={columns}
          rows={mappedRows}
          totalCount={kpiData?.totalCount || 0}
          serverPagination={true}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
          }}
        />
      </div>
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
          // setReceivePayment={handleGoToReceivePayment}
        />
      </Modal>
    </div>
  );
};
const RevenueFlowKpiViewModal = ({ isOpen, onClose, data }) => {
  const dispatch = useDispatch();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const rows = [
    {
      id: 1,
      uiid: 541,
      invoiceDate: "02/02/2026",
      transactionType: "Invoice",
      number: "16946",
      name: "NTT DATA Service Federal Gov.",
      memo: "Ravindra Rao (01/01/2026)",
      dueDate: "03/04/2026",
      amount: 19950.0,
      openingBalance: 19950.0,
    },
    {
      id: 2,
      uiid: 542,
      invoiceDate: "02/05/2026",
      transactionType: "Invoice",
      number: "16942",
      name: "Accenture LLP",
      memo: "Michael Scott (01/15/2026)",
      dueDate: "03/07/2026",
      amount: 12500.0,
      openingBalance: 12500.0,
    },
    {
      id: 3,
      uiid: 543,
      invoiceDate: "02/08/2026",
      transactionType: "Bill",
      number: "16951",
      name: "Deloitte Consulting",
      memo: "Sarah Johnson (01/20/2026)",
      dueDate: "03/10/2026",
      amount: 8750.0,
      openingBalance: 8750.0,
    },
    {
      id: 4,
      uiid: 544,
      invoiceDate: "02/10/2026",
      transactionType: "Invoice",
      number: "16950",
      name: "Infosys Ltd.",
      memo: "David Miller (01/25/2026)",
      dueDate: "03/12/2026",
      amount: 22300.0,
      openingBalance: 22300.0,
    },
    {
      id: 5,
      uiid: 545,
      invoiceDate: "02/12/2026",
      transactionType: "Credit Note",
      number: "16949",
      name: "Capgemini America",
      memo: "Emily Davis (01/28/2026)",
      dueDate: "03/14/2026",
      amount: -3200.0,
      openingBalance: -3200.0,
    },
    {
      id: 6,
      uiid: 546,
      invoiceDate: "02/15/2026",
      transactionType: "Invoice",
      number: "16948",
      name: "IBM Corporation",
      memo: "Robert Brown (02/01/2026)",
      dueDate: "03/17/2026",
      amount: 15600.0,
      openingBalance: 15600.0,
    },
    {
      id: 7,
      uiid: 547,
      invoiceDate: "02/18/2026",
      transactionType: "Bill",
      number: "16947",
      name: "Cognizant Technology",
      memo: "Olivia Wilson (02/05/2026)",
      dueDate: "03/20/2026",
      amount: 9400.0,
      openingBalance: 9400.0,
    },
    {
      id: 8,
      uiid: 548,
      invoiceDate: "02/20/2026",
      transactionType: "Invoice",
      number: "16952",
      name: "Tata Consultancy Services",
      memo: "James Anderson (02/07/2026)",
      dueDate: "03/22/2026",
      amount: 18250.0,
      openingBalance: 18250.0,
    },
  ];
  const columns = [
    { key: "invoiceDate", label: "Invoice Date", width: "text-nowrap!" },
    {
      key: "transactionType",
      label: "Transaction Type",
      width: "text-nowrap!",
    },
    {
      key: "number",
      label: "Number",
      width: "text-nowrap!",
      render: (row) => (
        <div
          className="text-info-500 cursor-pointer"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(
              getCurrentInvoiceStart({
                filters: { uiid: { type: "NONE", value: row.uiid } },
                coll: "Invoice",
                ref: "Client Employee Placement Timesheet",
                incl: ["", "firstName lastName", "", "attachments"],
              }),
            );
            setSelectedInvoice(row?.number);
          }}
        >
          {row?.number}
        </div>
      ),
    },
    {
      key: "name",
      label: "Name",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.name}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.name}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "memo",
      label: "Memo/ Description",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.memo}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1!">{row?.memo}</div>
        </SmartTooltip>
      ),
    },
    { key: "dueDate", label: "Due Date", width: "text-nowrap!" },
    { key: "amount", label: "Amount", width: "text-nowrap!", total: true },
    { key: "openingBalance", label: "Opening Balance", width: "text-nowrap!" },
  ];
  const mappedRows = mapTableRows(rows, columns);
  return (
    <div>
      <div className="flex gap-3">
        <Button
          size="md"
          title={"Back"}
          variant="text"
          icon={"arrow_left_alt"}
          color="black"
          className="px-0! bg-transparent!"
          onClick={onClose}
        />
      </div>
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          totalCount={rows?.length}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
          }}
        />
      </div>
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
          // setReceivePayment={handleGoToReceivePayment}
        />
      </Modal>
    </div>
  );
};

const ApDashboard = () => {
  const [revenueFlowModalOpen, setRevenueFlowModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i,
  );
  const [selectedYear, setSelectedYear] = useState(years[0]);
  const yearOptions = years.map((year) => ({
    label: year.toString(),
    value: year,
  }));
  const [modalData, setModalData] = useState(null);
  const [kpiModalOpen, setKpiModalOpen] = useState(false);
  const [kpiModalType, setKpiModalType] = useState(null);

  const [phoneModal, setPhoneModal] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    DropdownOptions[0].value,
  );
  const [reportPeriod, setReportPeriod] = useState(
    reportPeriodOptions[0].value,
  );
  const handleRevenueSelectChange = async (value) => {
    const revenueFlow = await fetchApRevenueFlow(value, selectedYear);
    setData((prev) => ({ ...prev, revenueFlow }));
    setSelectedOption(value);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [totalCounts, setTotalCounts] = useState({
    ag1: 0,
    ag2: 0,
  });
  const [data, setData] = useState({
    cardsData: [
      {
        title: "All Bills",
        value: formatCurrency(0),
      },
      {
        title: "Open Bills",
        value: formatCurrency(0),
      },
      {
        title: "Due Bills",
        value: formatCurrency(0),
      },
      {
        title: "Paid Bills",
        value: formatCurrency(0),
      },
    ],
    invoices: [],
    agingReport: [],
    infographicBar: {},
    revenueFlow: revenueFlowData,
  });

  const [dates, setDates] = useState({
    cards: {
      from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    },
    ag2: {
      from: null,
      to: null,
    },
  });

  const {
    page: ag1Page,
    limit: ag1Limit,
    setPage: ag1SetPage,
    handleLimitChange: ag1HandleLimitChange,
  } = usePagination(5);
  const {
    page: ag2Page,
    limit: ag2Limit,
    setPage: ag2SetPage,
    handleLimitChange: ag2HandleLimitChange,
  } = usePagination(5);
  //for datepickerrange
  // const handleDateRangeCards = (key, value) => {
  //   setDates((prevState) => ({ ...prevState, [key]: value }));
  // };
  //for monthpicker
  const handleDateRangeCards = (key, value) => {
    if (!value) return;

    const startOfMonth = new Date(value.getFullYear(), value.getMonth(), 1);
    const endOfMonth = new Date(value.getFullYear(), value.getMonth() + 1, 0);

    setDates((prevState) => ({
      ...prevState,
      [key]: {
        from: startOfMonth,
        to: endOfMonth,
      },
    }));
  };
  const handleCall = (number) => {
    const deepLink = `zoomphonecall:${encodeURIComponent(number)}`;
    window.location.href = deepLink;
  };

  const handleDashboardCalls = async () => {
    const startTime = performance.now();
    try {
      if (!dates.cards.from || !dates.cards.to) return;
      setIsLoading(true);
      const [dashboardCards, invoices, infoGraphicBar, revenueFlow] =
        await Promise.allSettled([
          fetchApDashboardCards(dates?.cards?.from, dates?.cards?.to),
          fetchBills(ag1Limit, ag1Page),
          fetchApInfoGraphicBar(),
          fetchApRevenueFlow(selectedOption, selectedYear),
        ]);
      setData((prev) => ({
        ...prev,
        cardsData: dashboardCards?.value || [],
        invoices: invoices?.value?.mappedInvoices || [],
        infographicBar: infoGraphicBar?.value || {},
        revenueFlow: revenueFlow?.value || [],
      }));
      setTotalCounts((prev) => ({
        ...prev,
        ag1: invoices?.value?.ag1TotalCount || 0,
      }));
      const endTime = performance.now();
      console.assert(
        import.meta.env.VITE_APP_ENV !== "local",
        `Time complexity: ${Number(endTime - startTime).toFixed(2)}ms`,
      );
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useLayoutEffect(() => {
    handleDashboardCalls();
  }, [dates?.cards?.from, dates?.cards?.to, ag1Page, ag1Limit]);
  const fetchAgingData = async () => {
    const data = await fetchApAgingReport(
      dates.ag2.from,
      dates.ag2.to,
      ag2Limit,
      ag2Page,
    );
    setData((prev) => ({
      ...prev,
      agingReport: data?.agingReport,
    }));
    setTotalCounts((prev) => ({
      ...prev,
      ag2: data?.ag2TotalCount || 0,
    }));
  };
  useEffect(() => {
    fetchAgingData();
  }, [ag2Page, ag2Limit]);

  const addActions = (values) => {
    return values.map((value) => ({
      ...value,
      Actions: (
        <div className="flex gap-2 items-center">
          <Button
            type="icon"
            icon={"call"}
            color="black"
            variant="text"
            onClick={() => {
              setPhoneModal(true);
              setModalData(value.roleContacts);
            }}
          />
          <Button
            type="icon"
            icon={"mail"}
            color="black"
            variant="text"
            onClick={() => {
              setEmailModal(true);
              setModalData(value.roleContacts);
            }}
          />
        </div>
      ),
    }));
  };

  const renderInfoBarExpandContent = () => (
    <div className="grid grid-cols-4 gap-5 mx-15 py-4">
      <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
        <span className="text-success-700 text-2xl font-semibold">
          {formatCurrency(
            Object.values(data?.infographicBar).reduce((a, b) => a + b, 0),
          )}
        </span>
        <p className="py-2">Total Payout</p>
        <span className="text-success text-sm">100% of Data</span>
      </div>

      <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
        {/* //take the peak vcalue from infographic bar object */}
        <span className="text-info-700 text-2xl font-semibold">
          {formatCurrency(Math.max(...Object.values(data?.infographicBar)))}
        </span>
        <p className="py-2">Peak Value</p>
        <span className="text-info text-sm">Best Period</span>
      </div>

      <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
        <span className="text-leave-700 text-2xl font-semibold">
          {Object.keys(data?.infographicBar)?.length > 0
            ? formatCurrency(
                Object.values(data?.infographicBar)?.reduce(
                  (a, b) => (a || 0) + (b || 0),
                  0,
                ) / 5,
              )
            : 0}
        </span>
        <p className="py-2">Average</p>
        <span className="text-leave text-sm">Per Period</span>
      </div>

      <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
        <span className="text-warning-700 text-2xl font-semibold">
          {Object.keys(data?.infographicBar)?.length - 1
            ? Object.keys(data?.infographicBar)?.length - 1
            : 0}
        </span>
        <p className="py-2">Time Periods</p>
        <span className="text-warning text-sm">Data Points</span>
      </div>
    </div>
  );
  const fetchBills = async (limit, page) => {
    try {
      const payload = {
        coll: "AccountPayable",
        lim: limit,
        pg: page,
        ref: "Vendor Employee",
        incl: ["businessName uiid roleContacts", "firstName lastName"],
        ret: "uiid dueDate invoiceNum invoiceDate vendorId employeeId amounts",
        fil: JSON.stringify({
          dueDate: {
            type: "LT",
            value: new Date(),
          },
          "amounts.due": { type: "EXCLUDE", value: 0 },
        }),
        sort: JSON.stringify({ dueDate: 1 }),
      };
      const totalPayload = {
        collection: "accountpayables",
        coll: "AccountPayable",
        filters: {
          dueDate: {
            type: "LT",
            value: new Date(),
          },
          "amounts.due": { type: "EXCLUDE", value: 0 },
        },
      };
      const [invoices, total] = await Promise.allSettled([
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.ACCOUNT_PAYBLES.GET_ALL,
          params: payload,
        }),
        getTotalCountApi(totalPayload),
      ]);
      const invoicesOverDue = invoices?.value?.data?.data || [];
      // const mappedInvoices = invoicesOverDue.map((i) => ({
      //   "Invoice Number": (
      //     <div className="flex items-center gap-1" key={i.uiid}>
      //       <span
      //         className="cursor-pointer text-linkblue"
      //         onClick={() => setSelectedInvoice(i?.uiid)}
      //       >
      //         {i.invoiceNum}
      //       </span>
      //     </div>
      //   ),
      //   "Vendor Name": i?.vendorId?.businessName || "",
      //   "Candidate Name":
      //     i?.employeeId?.[0]?.firstName + " " + i?.employeeId?.[0]?.lastName ||
      //     "",
      //   "Invoice Amount": i?.amounts?.billed,
      //   "Invoice Date": dayjs(i.invoiceDate).format("MM/DD/YYYY"),
      //   "Due Date": dayjs(i.dueDate).format("MM/DD/YYYY"),
      //   "Past In Due": `-${dayjs().diff(dayjs(i.dueDate), "days")}`,
      //   id: i.uiid,
      //   roleContacts: i?.clientId?.roleContacts || [],
      // }));
      const mappedInvoices = invoicesOverDue.map((i) => ({
        "Invoice Number": (
          <SmartTooltip
            description={i?.invoiceNum}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal
          >
            <div className="flex items-center gap-1" key={i.uiid}>
              <span
                className="cursor-pointer text-linkblue line-clamp-1"
                onClick={() => setSelectedInvoice(i?.uiid)}
              >
                {i.invoiceNum}
              </span>
            </div>
          </SmartTooltip>
        ),
        "Vendor Name": (
          <SmartTooltip
            description={i?.vendorId?.businessName}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal
          >
            <span className="line-clamp-1 w-[150px]! pr-1">
              {i?.vendorId?.businessName || ""}
            </span>
          </SmartTooltip>
        ),
        "Candidate Name": (
          <SmartTooltip
            description={`${i?.employeeId?.[0]?.firstName} ${i?.employeeId?.[0]?.lastName}`}
            size="xs"
            color="black"
            noicon
            tooltipPosition="bottom"
            portal
          >
            <span className="line-clamp-1">
              {`${i?.employeeId?.[0]?.firstName} ${i?.employeeId?.[0]?.lastName}` ||
                ""}
            </span>
          </SmartTooltip>
        ),
        "Invoice Amount": i?.amounts?.billed,
        "Invoice Date": dayjs(i.invoiceDate).format("MM/DD/YYYY"),
        "Due Date": dayjs(i.dueDate).format("MM/DD/YYYY"),
        "Past In Due": `-${dayjs().diff(dayjs(i.dueDate), "days")}`,
        id: i.uiid,
        roleContacts: i?.clientId?.roleContacts || [],
      }));
      return {
        mappedInvoices: mappedInvoices || [],
        ag1TotalCount: total?.value?.data?.data || 0,
      };
    } catch (error) {
      console.error("Error in fetchBills:", error);
    }
  };

  const renderRevenueExpandContent = () => (
    <div className="flex flex-col flex-1 gap-8 mx-10 py-4">
      <div className="grid grid-cols-6 gap-7 mx-2">
        {data?.revenueFlow?.map((rev) => (
          <div className="flex flex-col items-center px-5 py-3 rounded-xl border-2 border-gray-200 shadow-md">
            <span className="text-primary">{data?.label}</span>
            <ProgressBar
              value={rev?.revenue || 0}
              maxValue={data?.revenueFlow?.reduce(
                (acc, curr) => acc + curr.revenue,
                0,
              )}
              height="h-2"
              width="w-20"
              className={"my-2"}
            />
            <span className="text-xlfont-semibold">
              {formatCurrency(rev.value)}
            </span>
            <span
              className={`text-sm text-info mt-1 ${rev?.invoices ? "cursor-pointer" : ""}`}
              onClick={() => setRevenueFlowModalOpen(rev?.invoices)}
            >
              {rev?.invoices || 0}
            </span>
          </div>
        )) || []}
      </div>

      <div className="grid grid-cols-4 gap-5">
        <div className="flex flex-col bg-success-50 border border-success rounded-xl p-4 ">
          <span className="text-success-700 text-2xl font-semibold">
            {formatCurrency(
              data?.revenueFlow?.reduce((acc, curr) => acc + curr.revenue, 0),
            )}
          </span>
          <p className="py-2">Total Payouts</p>
          <span className="text-success text-sm">12 Months</span>
        </div>

        <div className="flex flex-col bg-info-50 border border-info rounded-xl p-4 ">
          <span className="text-info-700 text-2xl font-semibold">
            {data?.revenueFlow?.reduce((acc, curr) => acc + curr.invoices, 0)}
          </span>
          <p className="py-2">Total Bills</p>
          <span className="text-info text-sm">All Periods</span>
        </div>

        <div className="flex flex-col bg-leave-50 border border-leave rounded-xl p-4 ">
          <span className="text-leave-700 text-2xl font-semibold">
            {data?.revenueFlow?.reduce((acc, curr) => acc + curr.revenue, 0) /
            12
              ? formatCurrency(
                  data?.revenueFlow?.reduce(
                    (acc, curr) => acc + curr.revenue,
                    0,
                  ) / 12,
                )
              : 0}
          </span>
          <p className="py-2">Average Monthly</p>
          <span className="text-leave text-sm">Revenue</span>
        </div>

        <div className="flex flex-col bg-warning-50 border border-warning rounded-xl p-4 ">
          <span className="text-warning-700 text-2xl font-semibold">
            {Number(
              data?.revenueFlow?.reduce((acc, curr) => acc + curr.invoices, 0) /
                12,
            ).toFixed(2) || 0}
          </span>
          <p className="py-2">Average Bills</p>
          <span className="text-warning text-sm">Per Month</span>
        </div>
      </div>
    </div>
  );
  const renderAging1Content = () => (
    <h5 className="text-center text-2xl font-[600] mb-2">
      Aging Report Summary
    </h5>
  );

  const getDateRangeFromPeriod = (periodValue) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    switch (periodValue) {
      case 1:
        return { from: null, to: null };

      case 2:
        return { from: null, to: null };

      case 3:
        return { from: today, to: today };

      case 4:
        const dayOfWeek = today.getDay();
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - dayOfWeek);
        return { from: startOfWeek, to: today };

      case 5:
        const startOfMonth = new Date(currentYear, today.getMonth(), 1);
        return { from: startOfMonth, to: today };

      case 6:
        return {
          from: new Date(currentYear, 0, 1),
          to: new Date(currentYear, 2, 31),
        };

      case 7:
        return {
          from: new Date(currentYear, 3, 1),
          to: new Date(currentYear, 5, 30),
        };

      case 8:
        return {
          from: new Date(currentYear, 6, 1),
          to: new Date(currentYear, 8, 30),
        };

      case 9:
        return {
          from: new Date(currentYear, 9, 1),
          to: new Date(currentYear, 11, 31),
        };

      case 10:
        const lastYear = currentYear - 1;
        return {
          from: new Date(lastYear, 0, 1),
          to: new Date(lastYear, 11, 31),
        };

      default:
        return { from: null, to: null };
    }
  };

  const handleReportPeriodChange = (value) => {
    setReportPeriod(value);
    const dateRange = getDateRangeFromPeriod(value);
    setDates((prevState) => ({
      ...prevState,
      ag2: dateRange,
    }));
  };

  const renderAging2Content = () => (
    <div className="flex flex-col gap-x-4">
      {/* <h5 className="text-center text-2xl font-[600] mb-2">
        AP Summary Report
      </h5> */}
      <p className="text-center font-[500] mt-3">
        {dates.ag2.from
          ? `As of ${dayjs(dates.ag2.from).format("MMMM DD")}`
          : "\u00A0"}{" "}
        {dates.ag2.from && dates.ag2.to
          ? `- ${dayjs(dates.ag2.to).format("MMMM DD")}`
          : ""}
      </p>

      <div className="flex items-end gap-4 my-3">
        <div className="w-[180px]">
          <FormFieldSet
            title="Report Period"
            type="select"
            placeholder="Select"
            value={reportPeriod || ""}
            onChange={handleReportPeriodChange}
            options={reportPeriodOptions}
          />
        </div>
        {reportPeriod !== 1 && (
          <>
            <FormFieldSet
              title="From"
              type="datepicker"
              placeholder="Select Start Date"
              value={dates?.ag2?.from}
              showDropdown={false}
              onChange={(value) =>
                setDates((prevState) => ({
                  ...prevState,
                  ag2: { ...prevState.ag2, from: value },
                }))
              }
            />
            <FormFieldSet
              title="To"
              type="datepicker"
              placeholder="Select End Date"
              value={dates?.ag2?.to}
              showDropdown={false}
              onChange={(value) =>
                setDates((prevState) => ({
                  ...prevState,
                  ag2: { ...prevState.ag2, to: value },
                }))
              }
            />
          </>
        )}
        <Button title={"Apply"} onClick={() => fetchAgingData()} />
      </div>
    </div>
  );
  if (kpiModalOpen) {
    return (
      <KpiClickViewModal
        onClose={() => {
          setKpiModalOpen(false);
          setKpiModalType(null);
        }}
        data={null}
        dataType={kpiModalType}
        cardsDuration={dates?.cards}
      />
    );
  }

  return (
    <div className="px-1 py-2 flex flex-col gap-4">
      <>
        {import.meta.env.VITE_APP_ENV === "local" && (
          <div className="flex items-center justify-end col-span-2 w-max-[50px]">
            <Button
              onClick={() => {
                console.groupCollapsed("--- New Log Session ---");
                console.groupEnd();
                handleDashboardCalls();
              }}
              variant="outlined"
              icon="autorenew"
              title={"Refresh"}
            />
          </div>
        )}
      </>
      <div className="bg-[#FAFCFF] col-span-2 flex flex-col px-3 py-4 border border-gray-200 rounded-2xl shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h5>AP Dashboard Overview</h5>
          <div className="w-full max-w-[200px]">
            <FormFieldSet
              noTitle
              placeholder="Select date range"
              type="monthpicker"
              showDropdown={false}
              // value={{
              //   from: dates?.cards?.from || null,
              //   to: dates?.cards?.to || null,
              // }}
              value={dates?.cards?.from || null}
              onChange={(value) => handleDateRangeCards("cards", value)}
            />
          </div>
        </div>

        {/* <div className="grid grid-cols-4 gap-8 mt-4"> */}
        {/* <InfoWrapper>
          {data?.cardsData?.map((item, _idx) => (
            <InfoTimeCardAdv
              key={_idx}
              type="type3"
              title={item.title}
              value={item.value}
              prefix={item.prefix || ""}
              suffix={item.suffix || ""}
              variant="contained"
              color="primary"
            />
          )) || []}
        </InfoWrapper> */}
        <InfoWrapper className={"min-w-[250px]"}>
          {data?.cardsData?.map((item, _idx) => (
            <InfoCardNewAdv
              key={_idx}
              title={item.title}
              value={item.value}
              prefix={item.prefix || ""}
              suffix={item.suffix || ""}
              layout="option9"
              onClick={() => {
                setKpiModalType(item.title);
                setKpiModalOpen(true);
              }}
            />
          )) || []}
        </InfoWrapper>
        {/* </div> */}
      </div>

      <>
        {import.meta.env.VITE_APP_ENV === "local" && (
          <div className="flex-col items-center justify-start col-span-2 w-max-[50px] border border-primary p-2 rounded-lg">
            <div>Dev Note</div>
            <br />
            <div>Total AG1:{totalCounts.ag1}</div>
            <div>Total AG2:{totalCounts.ag2}</div>
          </div>
        )}
      </>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-[#FAFCFF] h-[340px] col-span-2 px-3 py-4 border border-gray-200 rounded-2xl shadow-lg">
          <ChartNew
            title="Aging Summary"
            expandIcon={false}
            type="tablechart"
            // expandedContent={renderAging1Content()}
            expandedContentPosition="top"
            rawData={data.invoices}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            chartLabel={"Candidate Name"}
            chartValue={"Past In Due"}
            chartToolbarRight={{
              chartToggle: true,
              expand: true,
            }}
            tableChartProps={{
              // if total prop is defined uncomment this line
              totalCount: totalCounts.ag1,
              hiddenFields: ["roleContacts"],
              hideToolBar: true,
              page: ag1Page,
              limit: ag1Limit,
              serverPagination: true,
              onPageChange: ag1SetPage,
              onLimitChange: ag1HandleLimitChange,
              hideToolBarInNormalView: true,
              hideToolBarInExpandedView: false,
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 xl:col-span-1">
          <ChartNew
            type="tablechart"
            title="Aging Report"
            expandedContent={renderAging2Content()}
            expandedContentPosition="top"
            chartToolbarRight={{
              chartToggle: false,
              expand: true,
            }}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={data.agingReport}
            chartLabel={"Vendor Name"}
            chartValue={"30-60"}
            tableChartProps={{
              // if total prop is defined uncomment this line
              totalCount: totalCounts.ag2,
              hideToolBar: true,
              page: ag2Page,
              limit: ag2Limit,
              serverPagination: true,
              onPageChange: ag2SetPage,
              onLimitChange: ag2HandleLimitChange,
              hideToolBarInNormalView: true,
              hideToolBarInExpandedView: false,
            }}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[340px] px-3 py-4 border border-gray-200 rounded-2xl shadow-lg col-span-2 xl:col-span-1">
          <ChartNew
            title="Infographic Bar"
            expandedContent={renderInfoBarExpandContent()}
            expandedChartWidth="w-[70%]"
            expandedChartHeight="h-[450px]"
            type="barchart"
            barChartProps={{
              steps: 5,
              depth: 300,
              barWidth: "60px",
            }}
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            rawData={[
              {
                label: "Current",
                value: data?.infographicBar?.current || 0,
              },
              {
                label: "1-30",
                value: data?.infographicBar?.upto30 || 0,
              },
              {
                label: "30-60",
                value: data?.infographicBar?.upto60 || 0,
              },
              {
                label: "60-90",
                value: data?.infographicBar?.upto90 || 0,
              },
              {
                label: "90+",
                value: data?.infographicBar?.over90 || 0,
              },
            ]}
            // formatYAxisTick={(val) => `$ ${val}`}
            formatYAxisTick={(val) => formatCurrency(val)}
            backgroundColor={"bg-[#FAFCFF]"}
            chartLabel={"label"}
            chartValue={"value"}
          />
        </div>

        <div className="bg-[#FAFCFF] h-[420px] col-span-2 flex flex-col flex-1 px-3 py-4 border border-gray-200 rounded-2xl shadow-lg">
          <ChartNew
            type="areachart"
            title="AP Flow Analysis"
            expandedContent={renderRevenueExpandContent()}
            expandedChartWidth="w-[95%]"
            expandedChartHeight="h-[350px]"
            barColors={[
              { color: "primary" },
              { color: "info" },
              { color: "leave" },
              { color: "draft", depth: 500 },
              { color: "success" },
            ]}
            barChartProps={{
              steps: 5,
              depth: 300,
            }}
            rawData={data.revenueFlow}
            width="w-full"
            height="h-full"
            chartLabel={"label"}
            chartValue={"value"}
            backgroundColor="bg-[#FAFCFF]"
            minPointGap={72}
            formatYAxisTick={(val) => formatCurrency(val)}
            steps={3}
            chartToolbarRight={{
              selectDropdown: true,
              selectDropdownOptions: DropdownOptions,
              selectDropdownValue: selectedOption,
              onSelectDropdownChange: handleRevenueSelectChange,
              chartToggle: true,
              expand: true,
              add: [
                {
                  component: (
                    <div className="flex gap-3">
                      <div className="flex justify-end items-end w-fit">
                        {import.meta.env.VITE_APP_ENV === "local" && (
                          <Button
                            variant="text"
                            icon="autorenew"
                            color="primary"
                            onClick={() => fetchApRevenueFlow("all", 2025)}
                          />
                        )}
                        <div className="w-[100px]">
                          <FormFieldSet
                            noTitle
                            placeholder="Select Year"
                            type="select"
                            size="sm"
                            value={selectedYear}
                            onChange={async (value) => {
                              //fetch data based on year change
                              if (!value) return;
                              if (value === selectedYear) return;
                              const revenueFlow = await fetchApRevenueFlow(
                                selectedOption,
                                value,
                              );
                              setData((prev) => ({ ...prev, revenueFlow }));

                              setSelectedYear(value);
                            }}
                            options={yearOptions}
                          />
                        </div>
                      </div>
                    </div>
                  ),
                },
              ],
            }}
            areaChartProps={{
              steps: 5,
              showValueLabel: true,
              depth: 400,
              renderToolTip: (data) => (
                <div className="flex flex-col gap-3 text-sm">
                  <span className="text-primary">{data.label}</span>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
                    Revenue:{" "}
                    <span className="text-primary">{data.revenue}</span>
                  </div>
                  <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
                    Invoices:{" "}
                    <span className="text-primary">{data.invoices}</span>
                  </div>
                </div>
              ),
            }}
          />
        </div>

        <Backdrop isOpen={isLoading} zIndex={60}>
          <LogoLoader />
        </Backdrop>
        <Modal
          isOpen={phoneModal}
          title={"Phone numbers"}
          onClose={() => {
            setPhoneModal(false);
            setModalData([]);
          }}
          closeOnOutsideClick={true}
          width="max-w-3xl"
          zIndex={1000}
        >
          {Array.isArray(modalData) && modalData.length > 0 ? (
            <div className="flex flex-col gap-4">
              {modalData.flatMap((contact, idx) => {
                const role = contact?.role?.trim() || "N/A";
                const name = contact?.name?.trim() || "N/A";
                const phones = Array.isArray(contact?.phone)
                  ? contact.phone
                  : [];

                return phones.length > 0 ? (
                  phones.map((phone, pIdx) => (
                    <div
                      key={`${idx}-${pIdx}`}
                      className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                    >
                      <span className="font-medium text-left">{role}</span>
                      <span className="text-sm text-gray-600 text-center">
                        {name}
                      </span>
                      <span
                        className={`text-sm text-linkblue text-right cursor-pointer`}
                        onClick={() => handleCall(phone?.code + phone?.number)}
                      >
                        {phone?.code + phone?.number || "N/A"}
                      </span>
                    </div>
                  ))
                ) : (
                  <div
                    key={`no-email-${idx}`}
                    className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                  >
                    <span className="font-medium text-center">{role}</span>
                    <span className="text-sm text-gray-600 text-center">
                      {name}
                    </span>
                    <span className="text-sm text-gray-400 text-center">
                      No Phone Number
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-6">
              <span className="font-medium text-gray-500">
                No contacts found
              </span>
            </div>
          )}
        </Modal>
        <Modal
          isOpen={emailModal}
          title={"Emails"}
          onClose={() => {
            setEmailModal(false);
            setModalData([]);
          }}
          closeOnOutsideClick={true}
          width="max-w-3xl"
          zIndex={1000}
        >
          {Array.isArray(modalData) && modalData.length > 0 ? (
            <div className="flex flex-col gap-4">
              {modalData.flatMap((contact, idx) => {
                const role = contact?.role?.trim() || "N/A";
                const name = contact?.name?.trim() || "N/A";
                const emails = Array.isArray(contact?.email)
                  ? contact.email
                  : [];

                return emails.length > 0 ? (
                  emails.map((email, pIdx) => (
                    <div
                      key={`${idx}-${pIdx}`}
                      className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                    >
                      <span className="font-medium text-left">{role}</span>
                      <span className="text-sm text-gray-600 text-center">
                        {name}
                      </span>
                      <span
                        className={`text-sm text-linkblue text-right ${
                          email
                            ? "cursor-pointer"
                            : "opacity-50 cursor-not-allowed"
                        }`}
                        onClick={() => email && window.open(`mailto:${email}`)}
                      >
                        {email || "N/A"}
                      </span>
                    </div>
                  ))
                ) : (
                  <div
                    key={`no-email-${idx}`}
                    className="grid grid-cols-3 gap-4 items-center border-b border-gray-200 pb-2"
                  >
                    <span className="font-medium text-center">{role}</span>
                    <span className="text-sm text-gray-600 text-center">
                      {name}
                    </span>
                    <span className="text-sm text-gray-400 text-center">
                      No Email
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-6">
              <span className="font-medium text-gray-500">
                No contacts found
              </span>
            </div>
          )}
        </Modal>
        <Modal
          isOpen={revenueFlowModalOpen}
          title={"Invoice Details"}
          onClose={() => setRevenueFlowModalOpen(null)}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
          zIndex={56}
        >
          <RevenueFlowKpiViewModal
            onClose={() => setRevenueFlowModalOpen(false)}
            data={null}
          />
        </Modal>
        <Modal
          isOpen={selectedInvoice}
          title={"AP Invoice Details"}
          onClose={() => setSelectedInvoice(null)}
          showCloseButton={true}
          closeOnOutsideClick={true}
          width="max-w-full"
          zIndex={56}
        >
          <ApInvoiceDetails
            invoiceUiid={selectedInvoice}
            onBack={() => setSelectedInvoice(null)}
            removeButtonForPreview={false}
          />
        </Modal>
      </div>
    </div>
  );
};

export default ApDashboard;
